import { classnames } from 'helpers/utils';
import './onboarding-glow.css';

// The steady halo and soft waves that invite a click on New (prototype's
// ButtonInvitationGlow). Sits inside the button's positioned wrapper.
export const ButtonInvitationGlow = ({ active }: { active: boolean }) => (
  <span
    className={classnames('button-invitation-glow', { 'is-active': active })}
    aria-hidden="true"
  >
    <span className="button-halo" />
    <span className="button-sonar">
      <i className="button-sonar-wave" />
      <i className="button-sonar-wave is-offset" />
    </span>
  </span>
);
